module.exports = __webpack_public_path__ + "img/p2-desc.4a26b6b3.png";